import { useEffect, useState } from 'react';
import api from '../utils/axios';
import { toLocalInputValue } from '../utils/DateUtil';

const useBookingForm = (initialData = null, dispatch = null) => {
  const [form, setForm] = useState({
    startDate: '',
    endDate: '',
    purpose: '',
    destination: '',
    office: '',
    preferredVehicle: '',
    approver: '',
    userPassengers: [],
    passengerToAdd: '',
    nonUserPassengers: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (initialData) {
      setForm({
        startDate: initialData.startDate ? toLocalInputValue(new Date(initialData.startDate)): '',
        endDate: initialData.endDate ? toLocalInputValue(new Date(initialData.endDate)): '',
        purpose: initialData.purpose || '',
        destination: initialData.destination || '',
        office: initialData.office || '',
        preferredVehicle: initialData.preferredVehicle?._id || '',
        approver: initialData.approver?._id || '',
        userPassengers: initialData.userPassengers?.map(p => p.user._id) || [],
        passengerToAdd: '',
        nonUserPassengers: (initialData.nonUserPassengers || []).join(', '),
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleOfficeChange = async (e) => {
    const selectedOffice = e.target.value;
    setForm(prev => ({ ...prev, office: selectedOffice, preferredVehicle: '' }));

    if (dispatch) {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get(`/api/vehicles/office/${selectedOffice}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch({ type: 'SET_VEHICLES', payload: res.data });
      } catch (err) {
        console.error('Failed to fetch vehicles:', err);
      }
    }
  };

  const addPassenger = () => {
    if (form.passengerToAdd && !form.userPassengers.includes(form.passengerToAdd)) {
      setForm(prev => ({
        ...prev,
        userPassengers: [...prev.userPassengers, prev.passengerToAdd],
        passengerToAdd: '',
      }));
    }
  };

  const removePassenger = (id) => {
    setForm(prev => ({
      ...prev,
      userPassengers: prev.userPassengers.filter(pid => pid !== id),
    }));
  };

  return {
    form,
    setForm,
    loading,
    setLoading,
    error,
    setError,
    handleChange,
    handleOfficeChange,
    addPassenger,
    removePassenger,
  };
};

export default useBookingForm;
